var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{attrs:{"mode":_vm.mode}},[_c('el-menu-item',{staticClass:"lad-install-pwa",attrs:{"index":"trips"},on:{"click":_vm.handleClick}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('pwa.install_manually_pwa')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }